import * as React from "react"
import { format } from "date-fns"
import { he } from "date-fns/locale"
import { CalendarIcon } from "lucide-react"

import { cn } from "../../lib/utils"
import { Button } from "../ui/Button"
import { Calendar } from "../ui/Calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/Popover"

export function DatePicker({ label, date, setDate, calenderComponentDisabled }) {
  const labelText = label === "start" ? "התחלה" : label === "end" ? "סיום" : label;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[190px] justify-start text-right font-normal gap-2 h-8 text-xs",
            !date && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="h-4 w-4 text-gray-500" />
          {date ? (
            <span>{format(date, "d בMMM yyyy", { locale: he })}</span>
          ) : (
            <span>תאריך {labelText}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={he}
          disabled={calenderComponentDisabled}
          toDate={new Date()}
          selected={date}
          onSelect={setDate.bind(null, label)}
          initialFocus
          defaultMonth={date}
        />
      </PopoverContent>
    </Popover>
  )
}

export { DatePicker as DatePickerDemo };